import { render, staticRenderFns } from "./user_change.mpx?vue&type=template&id=2e1b97b6&scoped=true&component=true&componentId=user_change2222576c"
import script from "./user_change.mpx?vue&type=script&lang=js&component=true&componentId=user_change2222576c"
export * from "./user_change.mpx?vue&type=script&lang=js&component=true&componentId=user_change2222576c"
import style0 from "./user_change.mpx?vue&type=style&index=0&id=2e1b97b6&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m2222576c%22%7D&component=true&componentId=user_change2222576c"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1b97b6",
  null
  
)

export default component.exports